import { useContext } from 'react';

import { ConfigContext } from './index';

export const useConfig = () => {
    return useContext(ConfigContext);
};
